import React from 'react';
import tw from 'twin.macro';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { SimpleTextWithIconsItem } from 'components/Lists/SimpleTextWithIconsList';
import { MarketingFeature } from 'types/plan';
import { StatusOpen } from '@teetsh/app/src/components/Icons/icons/StatusOpen';

interface Props {
  marketingFeaturesList: MarketingFeature[];
  className?: string;
}

export function PricingFeaturesList(props: Props) {
  const { marketingFeaturesList, className } = props;

  return (
    <ul className={className} tw="space-y-2 text-sm!">
      {marketingFeaturesList.map((feature, i) => {
        if (feature.status === 'unavailable') {
          return (
            <SimpleTextWithIconsItem key={i}>
              <XMarkIcon tw="h-5 w-5 text-danger-quiet" aria-hidden="true" />
              <span tw="text-neutral-quiet">{feature.label}</span>
            </SimpleTextWithIconsItem>
          );
        }

        if (feature.status === 'limited') {
          return (
            <SimpleTextWithIconsItem key={i}>
              <StatusOpen tw="h-5 w-5 text-neutral-supershy" />
              <span
                css={[
                  tw`text-neutral-quiet`,
                  feature.highlighted && tw`font-semibold`,
                ]}
              >
                {feature.label}{' '}
                {feature.limit && (
                  <span tw="text-warning-moderate text-nowrap">
                    ({feature.limit} {feature.limitType || 'max'})
                  </span>
                )}
              </span>
            </SimpleTextWithIconsItem>
          );
        }

        // status === 'available'
        return (
          <SimpleTextWithIconsItem key={i}>
            <CheckIcon tw="h-5 w-5 text-positive-quiet" aria-hidden="true" />
            <span
              css={[
                tw`text-neutral-intense`,
                feature.highlighted && tw`font-semibold`,
              ]}
            >
              {feature.label}
              {feature.limit && (
                <>
                  {' '}
                  <span tw="text-neutral-intense">
                    ({feature.limit} {feature.limitType || 'max'})
                  </span>
                </>
              )}
            </span>
          </SimpleTextWithIconsItem>
        );
      })}
    </ul>
  );
}
